
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
import * as Yup from "yup";
import { GoodToastIcon, CloseToastIcon } from "../../../components/common/IconComponents";
import Toast from "./Toast";

const MaintainRolesTab = () => {
  const initialValues = {
    email: "",
    firstName: "",
    lastName: "",
    role: "",
  };

  const [emailOptions, setEmailOptions] = useState([]); // State for email options

  // validation
  const validationSchema = Yup.object({
    email: Yup.string().required("Required"),
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    role: Yup.string().required("Required"),
  });

  // Toast state and toggle function and email
  const [showToast, setShowToast] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(""); // Track the selected email

  const toggleToast = () => {
    setShowToast(!showToast);
  };

  // Form submission
  const onSubmit = (values, { resetForm }) => {
    console.log("Form data", values);
    toggleToast();
    resetForm();
  };

  const handleEmailChange = (email) => {
    const selectedEmailData = getEmailData(email);
    setSelectedEmail(selectedEmailData);
  };

  const getEmailData = (email) => {
    // Simulate fetching data from an API based on the selected email
    // Replace this with your own logic to get the user data from the chosen email
    const emailData = {
      email: email,
      firstName: "John",
      lastName: "Doe",
      role: "Admin",
    };
    return emailData;
  };

  useEffect(() => {
    // Simulate fetching email options from an API
    // Replace this with your own logic to get the list of emails
    const fetchedEmailOptions = [
      { key: "Select", value: "" },
      { key: "example1@example.com", value: "example1@example.com" },
      { key: "example2@example.com", value: "example2@example.com" },
      { key: "example3@example.com", value: "example3@example.com" },
    ];
    setEmailOptions(fetchedEmailOptions);
  }, []);

  const roleOptions = [
    { key: "Select", value: "" },
    { key: "Admin", value: "Admin" },
    { key: "Analyst", value: "Analyst" },
  ];

  return (
    <section>
      <div className="md:px-4">
        {showToast && (
          <Toast
            message={`You have successfully changed ${selectedEmail.email} Role`}
            successIcon={<GoodToastIcon className="w-4 h-4 lg:w-8 lg:h-8" />}
            closeIcon={<CloseToastIcon />}
            onClose={toggleToast}
          />
        )}

        <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
          <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Maintain Roles</h1>
        </nav>

        <div className="mt-4 md:mt-24 mb-4">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => {
              return (
                <Form className="">
                  <FormikControl
                    control="select" // Changed control type to "select"
                    label="Email address"
                    name="email"
                    options={emailOptions} // Use the email options state
                    onChange={handleEmailChange} // Added onChange event handler
                  />

                  {selectedEmail && ( // Show the following fields only if an email is selected
                    <>
                      <FormikControl
                        control="input"
                        label="First name"
                        type="text"
                        name="firstName"
                        disabled
                        value={selectedEmail.firstName} // Set initial value from selected email data
                      />

                      <FormikControl
                        control="input"
                        label="Last name"
                        type="text"
                        name="lastName"
                        disabled
                        value={selectedEmail.lastName} // Set initial value from selected email data
                      />

                      <FormikControl
                        control="select"
                        label="Role"
                        name="role"
                        options={roleOptions} // Use the role options
                      />

                      <button
                        type="submit"
                        className="bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
                        disabled={!formik.isValid}
                      >
                        Save
                      </button>
                    </>
                  )}
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default MaintainRolesTab;




// FETCHING EMAIL FROM API
// import React, { useState } from "react";
// import { Formik, Form } from "formik";
// import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
// import * as Yup from "yup";
// import { GoodToastIcon, CloseToastIcon } from "../../../components/common/IconComponents";
// import Toast from "./Toast";

// const MaintainRolesTab = () => {
//   const initialValues = {
//     email: "",
//     firstName: "",
//     lastName: "",
//     role: "",
//   };

//   const [emailOptions, setEmailOptions] = useState([]); // State for email options

//   // validation
//   const validationSchema = Yup.object({
//     email: Yup.string().required("Required"),
//     firstName: Yup.string().required("Required"),
//     lastName: Yup.string().required("Required"),
//     role: Yup.string().required("Required"),
//   });

//   // Toast state and toggle function and email
//   const [showToast, setShowToast] = useState(false);
//   const [selectedEmail, setSelectedEmail] = useState(""); // Track the selected email

//   const toggleToast = () => {
//     setShowToast(!showToast);
//   };

//   // Form submission
//   const onSubmit = (values, { resetForm }) => {
//     console.log("Form data", values);
//     toggleToast();
//     resetForm();
//   };

//   const handleEmailChange = (email) => {
//     const selectedEmailData = getEmailData(email);
//     setSelectedEmail(selectedEmailData);
//   };

//   const getEmailData = (email) => {
//     // Simulate fetching data from an API based on the selected email
//     // Replace this with your own logic to get the user data from the chosen email
//     const emailData = {
//       email: email,
//       firstName: "John",
//       lastName: "Doe",
//       role: "Admin",
//     };
//     return emailData;
//   };

//   useEffect(() => {
//     // Simulate fetching email options from an API
//     // Replace this with your own logic to get the list of emails
//     const fetchedEmailOptions = [
//       { key: "Select", value: "" },
//       { key: "example1@example.com", value: "example1@example.com" },
//       { key: "example2@example.com", value: "example2@example.com" },
//       { key: "example3@example.com", value: "example3@example.com" },
//     ];
//     setEmailOptions(fetchedEmailOptions);
//   }, []);

//   return (
//     <section>
//       <div className="md:px-4">
//         {showToast && (
//           <Toast
//             message={`You have successfully changed ${selectedEmail.email} Role`}
//             successIcon={<GoodToastIcon className="w-4 h-4 lg:w-8 lg:h-8" />}
//             closeIcon={<CloseToastIcon />}
//             onClose={toggleToast}
//           />
//         )}

//         <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Maintain Roles</h1>
//         </nav>

//         <div className="mt-4 md:mt-24 mb-4">
//           <Formik
//             initialValues={initialValues}
//             validationSchema={validationSchema}
//             onSubmit={onSubmit}
//           >
//             {(formik) => {
//               return (
//                 <Form className="">
//                   <FormikControl
//                     control="select" // Changed control type to "select"
//                     label="Email address"
//                     name="email"
//                     options={emailOptions} // Use the email options state
//                     onChange={handleEmailChange} // Added onChange event handler
//                   />

//                   {selectedEmail && ( // Show the following fields only if an email is selected
//                     <>
//                       <FormikControl
//                         control="input"
//                         label="First name"
//                         type="text"
//                         name="firstName"
//                         disabled
//                         value={selectedEmail.firstName} // Set initial value from selected email data
//                       />

//                       <FormikControl
//                         control="input"
//                         label="Last name"
//                         type="text"
//                         name="lastName"
//                         disabled
//                         value={selectedEmail.lastName} // Set initial value from selected email data
//                       />

//                       <FormikControl
//                         control="select"
//                         label="Role"
//                         name="role"
//                         options={dropDownOptions}
//                       />

//                       <button
//                         type="submit"
//                         className="bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
//                         disabled={!formik.isValid}
//                       >
//                         Save
//                       </button>
//                     </>
//                   )}
//                 </Form>
//               );
//             }}
//           </Formik>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default MaintainRolesTab;
